var React = require('react');

function Mouse (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"wheel","cx":"123","cy":"150","r":"25","fill":"white","key":0}),React.createElement("path",{"id":"mouse","d":"M236.717,123.359c0,-62.565 -50.794,-113.359 -113.358,-113.359c-62.565,0 -113.359,50.794 -113.359,113.359l0,143.237c0,62.565 50.794,113.359 113.359,113.359c62.564,0 113.358,-50.794 113.358,-113.359l0,-143.237Z","style":{"fill":"none","stroke":"#fff","strokeWidth":"20px"},"key":1})]);
}

Mouse.defaultProps = {"viewBox":"0 0 247 390","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"1.5"}};

module.exports = Mouse;

Mouse.default = Mouse;
